import React, { PropsWithChildren } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import './PartnerOfferForm.css';
import { PhaVariant } from './variants/PhaVariant';
import { SkipPqPrefillVariant } from './variants/SkipPqPrefillVariant';

export interface IPartnerOfferFormProps extends MappedComponentProperties {
    applicationPagePath?: string;
    variant?: string;
}

export const PartnerOfferFormEditConfig = {
    emptyLabel: 'Partner Offer Form',
    isEmpty: (props: PropsWithChildren<IPartnerOfferFormProps>) => {
        return !props.variant;
    },
};

const PartnerOfferForm = (props: PropsWithChildren<IPartnerOfferFormProps>): JSX.Element => {
    
    return props.variant === 'skipPQ-Prefill' ? <SkipPqPrefillVariant {...props}/> : <PhaVariant {...props} />;
};

export default PartnerOfferForm;
